<template>
  <div>
    <div class="launch-content" v-show="isShowList">
      <MediaFactoryTabs  activeType="mediaIndex">
        <template slot="serachContent">
           <div>
      <el-input
          size="small"
          placeholder="请输入物料名称"
          class="input-with-select"
          clearable
          v-noEmoji
           maxlength="45"
           @keyup.enter.native="handleSearch"
           v-model="filter.materialName"
        >
          <el-select slot="prepend" placeholder="请选择广告位" v-model="filter.spaceId"  style="width:190px" clearable>
            <el-option v-for="item in spaceOptions" :key="item.value" :label="item.label" :value="item.value" ></el-option>
          </el-select>
          <el-button @click="handleSearch" slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
        </template>
        <span slot="mediaIndex">
          <List @create="handleCreate" @edit="handleEdit" @read="handleRead" ref="list" :searchParams="filter" />
        </span>
      </MediaFactoryTabs>
    </div>
    <div v-if="!isShowList">
      <Add :id="id" :mode="mode" @go-back="handleGoBack"></Add>
    </div>
  </div>
</template>
<script>
import MediaFactoryTabs from '@/views/mediaFactory/components/MediaFactoryTabs'
import List from '@/views/mediaFactory/media/MediaList'
import Add from '@/views/mediaFactory/media/MediaAdd'

export default {
  components: { MediaFactoryTabs, List, Add },
  data() {
    return {
      isShowList: true,
      id: undefined,
      mode: 'create',
      filter: {
        name: undefined,
        spaceId: undefined
      },
      spaceOptions: []
    }
  },
  methods: {
    handleCreate() {
      this.isShowList = false
    },
    handleEdit() {

    },
    handleRead() {

    },
    handleGoBack() {
      this.isShowList = true
      this.$refs.list.fetchData()
    },
    handleSearch() {
      this.$refs.list.fetchData()
    },
    getSpaceList() {
      this.$service.getVideoSpaceList().then(data => {
        this.spaceOptions = (data || []).map(item => {
          return {
            label: item.spaceName,
            value: item.spaceId
          }
        })
      })
    }
  },
  created() {
    this.getSpaceList()
  }

}
</script>
